function RotatingWords() {
  return (
    <div className='rwords'>
      <div className='content'>
        <div className='content__container'>
          <ul className='content__container__list'>
            <li className='content__container__list__item'>Developer</li>

            <li className='content__container__list__item'>Creative</li>
            <li className='content__container__list__item'>Leader</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default RotatingWords;
